import type {SupplierFunctionList} from "../../../types/supplierFunctions.types";

import {deleteSupplierFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {supplierFunctionKeys, supplierFunctionMutationKeys} from "../../../supplierFunction-keys";

export function deleteSupplierFunctionMutationOptions() {
  const listFilter = {queryKey: supplierFunctionKeys.lists()};

  return mutationOptions({
    mutationFn: (supplierFunctionId: string) => deleteSupplierFunction(supplierFunctionId),
    mutationKey: supplierFunctionMutationKeys.deleteSupplierFunction,
    onMutate: async (deletedId, {client}) => {
      await client.cancelQueries(listFilter);
      const previousLists = client.getQueriesData<SupplierFunctionList>(listFilter);

      for (const [key, list] of previousLists) {
        const params = key[2];

        if (
          !list ||
          typeof params !== "object" ||
          params === null ||
          !("state" in params) ||
          params.state !== "ACTIVE" ||
          !list.items.some((item) => item.supplierFunctionId === deletedId)
        ) {
          continue;
        }

        client.setQueryData<SupplierFunctionList>(key, {
          ...list,
          items: list.items.filter((item) => item.supplierFunctionId !== deletedId),
          meta: {...list.meta, total: Math.max(0, list.meta.total - 1)},
        });
      }

      return {previousLists};
    },
    onError: (_error, _deletedId, context, {client}) => {
      for (const [key, snapshot] of context?.previousLists ?? []) {
        client.setQueryData(key, snapshot);
      }
    },
    onSuccess: async (_data, deletedId, _context, {client}) => {
      client.removeQueries({queryKey: supplierFunctionKeys.detail(deletedId)});
      await client.invalidateQueries(listFilter);
    },
  });
}
